import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import CustomDatePicker from "../../../../../components/CustomDatePicker";
import Input from "../../../../../components/Input";
import Text from "../../../../../components/Text";
import SignatureInput from "../../../../../components/signiture/SignatureInput";
import { useSignatureController } from "../../../../../components/signiture/use-signature-controller";

const PRESCRIPTION_POLICIES = [
  {
    text: "Please do not wait until your last pill to call for a refill. There is a 72 hour turn around for prescription refills. If you have not seen the Physician in six months, the prescription will be Denied.",
  },
];

interface IntakePrescriptionPolicyProps {
  values: any;
  setFieldValue: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  submitCount: number;
  viewOnly?: boolean;
}

const IntakePrescriptionPolicy = ({
  values,
  setFieldValue,
  handleChange,
  handleBlur: _handleBlur,
  touched: _touched,
  errors: _errors,
  submitCount,
  viewOnly,
}: IntakePrescriptionPolicyProps) => {
  const [k, setK] = useState<boolean>(true);
  const { canvasRef, signPad, isSignEmpty } = useSignatureController(k);

  return (
    <Box mt={1}>
      <Divider textAlign="left">
        <Text>PRESCRIPTION POLICY</Text>
      </Divider>

      {/* Pharmacy Information */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Input
            label="Pharmacy Name"
            textFieldProps={{
              name: "pharmacyName",
              value: values.pharmacyName,
              onChange: handleChange,
              placeholder: "Enter Pharmacy Name",
              disabled: viewOnly,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input
            label="Pharmacy Phone Number"
            textFieldProps={{
              name: "pharmacyPhone",
              value: values.pharmacyPhone,
              onChange: handleChange,
              placeholder: "Enter Phone Number",
              disabled: viewOnly,
            }}
          />
        </Grid>
      </Grid>

      {/* Policy List */}
      <List
        sx={{
          "& .MuiListItem-root": {
            alignItems: "flex-start",
            gap: 1,
          },
          "& .MuiListItemIcon-root": {
            minWidth: "auto",
            mt: 1,
            "& .MuiSvgIcon-root": {
              fontSize: "8px",
            },
          },
        }}
      >
        {PRESCRIPTION_POLICIES.map((policy, index) => (
          <ListItem key={index} sx={{ py: 0 }}>
            <ListItemIcon>
              <CircleIcon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Text variant="body2" color="textPrimary">
                  {policy.text}
                </Text>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Signature Section */}
      <CustomDatePicker
        disabled={viewOnly}
        label="Date"
        name="signatureDate"
        placeholder="Select Date"
        value={values.signatureDate ? dayjs(values.signatureDate) : null}
        onChange={(value) => setFieldValue("signatureDate", value)}
        maxDate={dayjs()}
      />

      <Grid item container>
        {viewOnly ? (
          <img
            src={values.intakePrescriptionPolicySign}
            style={{ height: "150px", width: "580px" }}
          />
        ) : (
          <Box
            position={"relative"}
            onMouseLeave={() => {
              if (!isSignEmpty() && signPad?.toDataURL()) {
                setFieldValue(
                  "intakePrescriptionPolicySign",
                  signPad?.toDataURL()
                );
              }
            }}
          >
            <SignatureInput
              required
              error={submitCount > 0 && isSignEmpty()}
              label="Signature"
              canvasRef={canvasRef}
              w="580px"
              h="150px"
            />

            <Button
              variant="contained"
              sx={{
                position: "absolute",
                bottom: 6,
                right: -56,
                height: "24px",
              }}
              onClick={() => {
                setK((prev) => !prev);
                signPad?.clear();
              }}
            >
              clear
            </Button>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default IntakePrescriptionPolicy;
